import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { PUBLIC_PAGE_ROUTES } from '@/enums';
import { DetailsPagePassword } from '@/pages/SetPassword/DetailsPage';
import { LeftChevronBlackIcon as ArrowLeftIcon, EmailIcon as Email } from '@/resources';

export const CheckEmailPage = () => {
  const navigate = useNavigate();
  const [t] = useTranslation('common');

  return (
    <DetailsPagePassword>
      <div className='z-[100] h-80 w-[90%] rounded-3xl bg-primary-white p-14 sm:w-2/6'>
        <div className='mb-3 mt-0 flex justify-center'>
          <Email className='h-9 w-10 justify-center' />
        </div>
        <div className='mb-5 flex justify-center text-2xl font-bold text-primary-blue'>
          {t('checkYourEmail')}
        </div>
        <div className='mb-2 text-center'>
          {t('pleaseCheckEmail')}
          <Link className='font-bold text-primary-blue underline' to={PUBLIC_PAGE_ROUTES.SEND_EMAIL}>
            {t('resend')}
          </Link>
        </div>
        <div className='flex justify-center'>
          <Button
            variant={ButtonVariant.TERTIARY}
            handleOnClick={() => navigate(PUBLIC_PAGE_ROUTES.LOGIN)}
            className='mt-5 flex border-0'>
            <ArrowLeftIcon className='mr-2 text-base' />
            {t('backToLogin')}
          </Button>
        </div>
      </div>
    </DetailsPagePassword>
  );
};
